import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, SecurityContext, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { ClearTextDirectiveDirective } from '../../directives/clear-text-directive.directive';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';

@Component({
  selector: 'adm-text-search',
  templateUrl: './text-search.component.html',
  styleUrls: ['./text-search.component.scss'],
  imports: [ClearTextDirectiveDirective, MatFormField, MatLabel, MatIcon, ReactiveFormsModule, MatInput],
})
export class TextSearchComponent implements OnInit {
  private sanitizer = inject(DomSanitizer);
  private element = inject<ElementRef<HTMLInputElement>>(ElementRef);

  @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (event.key === 'Escape' && document.activeElement === this.element.nativeElement) {
      this.reset();
    }
  }

  public searchControl = new FormControl<string>('', { nonNullable: true });

  @Input()
  public type: string;

  @Input()
  public searchText: string;

  @Input()
  public placeholder?: string;

  @Input()
  public displaySearchIcon?: boolean;

  @Output()
  public search$: EventEmitter<Observable<string>>;

  constructor() {
    this.search$ = new EventEmitter();
    this.type = 'text';
    this.searchText = '';
    this.placeholder = 'Søg';
    this.displaySearchIcon = true;
  }

  ngOnInit(): void {
    this.searchControl.setValue(this.searchText);

    const searchPipe$ = this.searchControl.valueChanges.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      tap(searchTerm => this.sanitizer.sanitize(SecurityContext.URL, searchTerm))
    );

    this.search$.emit(searchPipe$);
  }

  public reset() {
    this.searchControl.setValue('');
  }
}
